import { render, staticRenderFns } from "./modalTable.vue?vue&type=template&id=22b09a8e&scoped=true&"
import script from "./modalTable.vue?vue&type=script&lang=js&"
export * from "./modalTable.vue?vue&type=script&lang=js&"
import style0 from "./modalTable.vue?vue&type=style&index=0&id=22b09a8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b09a8e",
  null
  
)

export default component.exports